import { Route, createPageRoute, AppId } from '@lumapps/router';

const formsRoute: Route = createPageRoute({
    slug: 'forms',
    appId: AppId.backOffice,
});

export { formsRoute };
